import React, { useState } from "react";
import ActiveBlockContainerStore from "../../stores/ActiveBlockContainerStore.mjs";
import {
  handleThemeLinkInheritanceFromPropInfo,
  applyPropInfoToTheme,
} from "../../utils/SyncUtils";
import DesignSettingsGlobal from "./DesignSettingsGlobal";
import DesignSettingsPreview from "./DesignSettingsPreview";
import DesignSettingsTypeStyles from "./DesignSettingsTypeStyles";
import { TEXT_LINK } from "../../constants/MergeConstants";

export const isLinkPropPath = (path) => path.includes(TEXT_LINK);

const DesignSettingsStyle = ({ theme: newTheme, setTheme, designContext }) => {
  const [selectedType, setSelectedType] = useState("title");
  const [showInlineLinkPreview, setShowInlineLinkPreview] = useState(false);
  const newThemeColors = newTheme.get("colors").toJS();
  const selectedLayout = ActiveBlockContainerStore.getSelectedLayout();

  const _onPropChange = (initialPropInfo) => {
    let updatedTheme = newTheme;
    const propInfo = !Array.isArray(initialPropInfo) ? [initialPropInfo] : initialPropInfo;

    if (propInfo.length === 1 && isLinkPropPath(propInfo[0].name)) {
      updatedTheme = handleThemeLinkInheritanceFromPropInfo(updatedTheme, propInfo);
    } else {
      propInfo.forEach((info) => {
        updatedTheme = applyPropInfoToTheme(updatedTheme, info);
      });
    }

    setTheme(updatedTheme);
  };

  return (
    <>
      <div className="theme-settings-section">
        <div className="panel-design-settings">
          <DesignSettingsTypeStyles
            onChange={_onPropChange}
            newTheme={newTheme}
            selectedLayout={selectedLayout}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            palette={newThemeColors}
            setTheme={setTheme}
            showInlineLinkPreview={showInlineLinkPreview}
            setShowInlineLinkPreview={setShowInlineLinkPreview}
          >
            <DesignSettingsGlobal
              onChange={_onPropChange}
              bgPalette={newThemeColors}
              newTheme={newTheme}
              selectedLayout={selectedLayout}
            />
          </DesignSettingsTypeStyles>
        </div>
        <DesignSettingsPreview
          newTheme={newTheme}
          selectedLayout={selectedLayout}
          showInlineLinkPreview={showInlineLinkPreview}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
          designContext={designContext}
        />
      </div>
    </>
  );
};

export default DesignSettingsStyle;
